<template>
  <div>
    <el-upload ref="elUpload" v-if="businessType !== 'fileList'"
               class="upload-demo"
               :action="uploadUrl"
               :before-remove="beforeFileRemove"
               :on-success="handleSuccess"
               :data="{
                 'businessType': businessType,
                 'targetId': targetId,
                 'accessToken': accessToken
               }"
               :show-file-list="false"
               :multiple="multiple"
    ><el-button size="small" type="primary">点击上传</el-button>
      <div class="el-upload__tip" slot="tip">{{uploadTips}}{{tip}}</div>
    </el-upload>

    <div class="fileList" v-for="file in fileList">
      <div class="fileItem">
        <a class="fileItemText" href="javascript:void(0)" @click="downloadFile(file.id)">{{file.fileName}}</a>
        <i class="el-icon-close hand" @click="removeFile(file.id)"v-if="businessType !== 'fileList'"/>
      </div>
    </div>
  </div>
</template>

<script>
import {getToken} from "../../utils/auth";
import {mapGetters} from "vuex";

export default {
  name: "xrUploadFiles",
  props: ['businessType', 'targetId', 'uploadUrl','multiple'],
  data(){
    return{
      fileList: [],                        //文件列表
      accessToken: '',
      //备注
      // tip: '\n文件大小不得超过200M'
    }
  },
  created() {
    this.accessToken = getToken();
  },
  watch: {
    // targetId(newTargetId, oldTargetId) {
    //   if (newTargetId !== oldTargetId) {
    //     this.fileList = [];
    //   }
    // },
    // 监听 fileList 变化，更新上传参数并重新加载资源列表
    fileList(list) {
      this.$emit('confirm', list);
    },
  },
  components: {
  },
  computed: {
    ...mapGetters([
      'uploadTips','tip'
    ]),
  },
  beforeMount() {
  },
  methods: {
    //移除文件方法
    beforeFileRemove(file) {
      let id = file.response.resourceId;
      return this.request({
        method: 'post',
        url: '/fileWeb/deleteFile',
        params: {
          'id': id
        }
      }).then((response) => {
        // 请求成功返回的数据
        //如果返回编码不为0，提示失败语
        if (response.code != '0') {
          this.$message.error(response.msg);
          return false;
        }
        return true;
      })
    },
    // 上传成功时的回调
    handleSuccess(response) {
      // 如果返回的编码不为 '0'，表示上传失败，提示错误
      if (response.code != '0') {
        this.$message.error(response.msg);
        return false;
      }
      // 手动将上传成功的文件添加到 fileList
      let uploadedFile = {
        id: response.resourceId,
        fileName: response.fileName
      };

      this.fileList.push(uploadedFile);
      this.$emit('uploadFile',this.fileList);
      // this.$message.success('上传成功');
    },
    downloadFile(id){
      let dUrl =  process.env.FILE_URL + '/fileWeb/getResource/' + id;
      window.open(dUrl, "_blank");
    },
    removeFile(id){
        return this.request({
          method: 'post',
          url: '/fileWeb/deleteFile',
          params: {
            'id': id
          }
        }).then((response) => {
          // 请求成功返回的数据
          //如果返回编码不为0，提示失败语
          if (response.code != '0') {
            this.$message.error(response.msg);
            return false;
          }
          const index = this.fileList.findIndex(file => file.id === id);
          this.fileList.splice(index,1);
          this.$emit('removeFile',this.fileList);
          return true;
        })
    }
  }

}
</script>

<style scoped>
.hand{
  margin-left: 15px;
  cursor: pointer;
}
.fileItemText{color: blue}
.fileItemText:hover{color:lightblue; text-decoration: underline;}

</style>



// WEBPACK FOOTER //
// src/components/XrUploadFiles/index.vue